<template>
  <div :class="$store.state.menu.finalizacaoPedido == true ? $vssWidth > 1000 ? $vssWidth > 1300 ? $vssWidth > 1580 ? 'content' : 'content2' : 'content3': 'content4' : 'content'">

    <div v-if="$store.state.menu.finalizacaoPedido == true" class="etapas">
      <input type="submit" class="btn-ativo" value="1" />
      <div class="linha"></div>
      <input type="submit" class="btn-inativo" value="2" />
      <div class="linha"></div>
      <input type="submit" class="btn-inativo" value="3" />
    </div>

    <div v-if="$store.state.menu.finalizacaoPedido == true" class="etapas-titulo">
      <p class="p-ativo primeiro">Etapa 1:<br>login ou cadastro</p>
      <div class="linha-espaco"></div>
      <p class="p-inativo">Etapa 2:<br>pagamento</p>
      <div class="linha-espaco"></div>
      <p class="p-inativo ultimo">Etapa 3:<br>concluído</p>
    </div>
    <div class="container4">
      <div class="login">
          <p class="titulo">JÁ COMPROU NO ILHA?</p>
          <div class="form">
            <button class="bt-google" @click="loginExterno('Google')"><i class="fab fa-google"></i>  Acesse com Google</button>
              <button class="bt-facebook" @click="loginExterno('Facebook')"><i class="fab fa-facebook"></i>  Acesse com Facebook</button>
            <p class="margin-top">ou</p>
            <form @submit.prevent="acessarCpf">
              <input v-model="cpf" v-mask="'###.###.###-##'" required type="text" name="cpf" placeholder="000.000.000-00">
              <button type="submit" class="bt-cpf">Acesse com o seu CPF</button>
            </form>
          </div>
          <p class="titulo">É A SUA PRIMEIRA VEZ?</p>
          <div class="form">
              <span class="cadastrar" @click="cadastrar()">
                <button type="submit" class="bt-login">Faça o seu cadastro!</button>
              </span>
          </div>

        <div>
        <p class="titulo">FAÇA O SEU LOGIN</p>
          <div class="form">
            <form @submit.prevent="login">
              <p class="label">E-mail:</p>
              <input ref="email" v-model="formLogin.email" type="email" name="email" placeholder="digite seu e-mail">
              <p class="label">Senha:</p>
              <input ref="senha" v-model="formLogin.password" type="password" name="senha" placeholder="digite sua senha">
              <button type="submit" class="bt-login">Fazer login</button>
            </form>
            <p class="esqueci-senha" @click="esqueciMinhaSenha()">Esqueceu sua senha? Clique aqui</p>
          </div>
          <div class="form" v-if="this.$store.state.usuario.loginCpf === true">
            <button class="bt-google" @click="loginExterno('Google')"><i class="fab fa-google"></i>  Acesse com Google</button>
            <button class="bt-facebook" @click="loginExterno('Facebook')"><i class="fab fa-facebook"></i>  Acesse com Facebook</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { dbCadastro, auth, googleProvider, facebookProvider } from '@/firebase_cadastro.js'
import { mapActions } from 'vuex'
import VueScreenSize from 'vue-screen-size'
import cupom from '../methods/Cupom'

export default {
  ...cupom,
  name: 'Login',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data: function () {
    return {
      usuario: null,
      cpf: null,
      formLogin: {
        email: this.$store.state.usuario.usuarioProvisorio != null ? this.$store.state.usuario.usuarioProvisorio.Email : null,
        password: null
      },
      imageBytes: null
    }
  },
  created () {
    this.entrarLogin()
  },
  destroyed () {
    this.sairLogin()
  },
  methods: {
    ...mapActions('usuario', ['usuarioAtual', 'loginCpf', 'usuarioProvisorio', 'usuarioProvisorioLogout', 'loginGoogleFacebook']),
    ...mapActions('menu', ['finalizacaoPedido']),
    ...mapActions('configuracoes', ['loginView']),
    async esqueciMinhaSenha () {
      var urlAposReset = {
        url: 'https://ilhadocaranguejo.com.br/login',
        handleCodeInApp: false
      }
      this.$fire({
        text: 'Informe o seu email para receber a sua nova senha',
        input: 'text',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        preConfirm: text => {
          dbCadastro.collection('Clientes').doc(text).get().then((doc) => {
            if (doc.exists) {
              if (doc.data().FormaLogin !== 'Convencional') {
                this.$fire({
                  title: 'O seu e-mail está cadastrado para acesso com o ' + doc.data().FormaLogin,
                  text: 'Para acessar o sistema com o login do ' + doc.data().FormaLogin + ', clique em "OK".',
                  type: 'warning',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar'
                }).then(r => {
                  if (r.value) {
                    this.loginExterno(doc.data().FormaLogin)
                  }
                })
              } else {
                auth.sendPasswordResetEmail(text, urlAposReset).then(() => {
                  this.$alert('E-mail enviado!')
                })
              }
            } else {
              this.$fire({
                title: 'Não foi possível enviar a sua senha',
                text: 'Não encontramos o seu e-mail cadastrado em nosso sistema.',
                type: 'error'
              })
            }
          }).catch((error) => {
            console.log(error)
            this.$fire({
              title: 'Não foi possível enviar a sua senha',
              text: 'Não encontramos o seu e-mail cadastrado em nosso sistema.',
              type: 'error'
            })
          })
        }
      })
    },
    focarSenha () {
      this.$refs.senha.focus()
    },
    entrarLogin () {
      this.loginView(true)
    },
    sairLogin () {
      this.loginView(false)
    },
    cadastrar () {
      this.$router.push({name: 'Cadastrar'})
    },
    acessarCpf () {
      dbCadastro.collection('Clientes').where('Cpf', '==', this.cpf).limit(1).get().then((querySnapshot) => {
        if (querySnapshot.empty) {
          this.$fire({
            title: 'CPF não encontrado',
            text: ' Clique em OK para fazer seu cadastro!',
            type: 'error',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'
          }).then(r => {
            if (r.value) {
              this.usuarioProvisorio({
                Cpf: this.cpf
              })
              this.$router.push({name: 'Cadastrar'})
            }
          })
        } else {
          querySnapshot.forEach((doc) => {
            var usuario = doc.data()
            if (usuario.PrimeiroAcesso === false) {
              if (usuario.FormaLogin === 'Google') {
                this.$fire({
                  title: 'Encontramos o seu CPF',
                  text: 'Ele está vinculado ao email ' + doc.data().Email + ' com login através do Google. Como é o seu primeiro acesso, confira os seus dados para continuar.',
                  type: 'success'
                })
                this.loginGoogleFacebook(true)
              } else if (usuario.formaLogin === 'Facebook') {
                this.$fire({
                  title: 'Encontramos o seu CPF',
                  text: 'Ele está vinculado ao email ' + doc.data().Email + ' com login através do Facebook. Como é o seu primeiro acesso, confira os seus dados para continuar.',
                  type: 'success'
                })
                this.loginGoogleFacebook(true)
              } else {
                this.$fire({
                  title: 'Encontramos o seu CPF',
                  text: 'Crie uma senha e confira os seus dados para continuar.',
                  type: 'success'
                })
              }
              this.usuarioProvisorio(usuario)
              this.$router.push({name: 'Cadastrar'})
            } else {
              this.$fire({
                title: 'Encontramos o seu CPF em nosso cadastro!',
                text: doc.data().FormaLogin !== null ? 'CPF informado já está cadastrado com o E-mail ' + doc.data().Email + ' Com o acesso via ' + doc.data().FormaLogin : 'Acesse com sua senha ou com sua conta do Google ou Facebook',
                type: 'info',
                confirmButtonText: 'Fazer Login',
                showCancelButton: true,
                cancelButtonText: 'Cancelar'
              }).then(r => {
                if (doc.data().FormaLogin !== null) {
                  if (doc.data().FormaLogin === 'Google') {
                    this.loginExterno('Google')
                  } else if (doc.data().FormaLogin === 'Facebook') {
                    this.loginExterno('Facebook')
                  } else if (doc.data().FormaLogin === 'Convencional') {
                    this.usuarioProvisorio(usuario)
                    this.formLogin.email = usuario.Email
                    setTimeout(() => this.$refs.email.focus(), 500)
                  } else {
                    this.usuarioProvisorio(usuario)
                    this.$router.push({name: 'Cadastrar'})
                  }
                } else {
                  this.usuarioProvisorio(usuario)
                  this.$router.push({name: 'Cadastrar'})
                }
              })
            }
          })
        }
      })
    },
    async loginConvencional () {
      await auth.signInWithEmailAndPassword(this.formLogin.email, this.formLogin.password)
        .then(async (data) => {
          await dbCadastro.collection('Clientes').doc(data.user.email).get().then((doc) => {
            this.usuario = {
              id: data.user.uid,
              Email: doc.data().Email,
              Telefone: doc.data().Telefone,
              PrimeiroNome: doc.data().PrimeiroNome,
              UltimoNome: doc.data().UltimoNome,
              NomeCompleto: doc.data().NomeCompleto,
              Cpf: doc.data().Cpf,
              Token: data.user.xa,
              Foto: data.user.photoURL,
              EnderecoCep: doc.data().EnderecoCep,
              EnderecoRua: doc.data().EnderecoRua,
              EnderecoNumero: doc.data().EnderecoNumero,
              EnderecoBairro: doc.data().EnderecoBairro,
              EnderecoComplemento: doc.data().EnderecoComplemento,
              EnderecoCidade: doc.data().EnderecoCidade,
              EnderecoUF: doc.data().EnderecoUF
            }
          })
          this.loginCpf(false)
          this.usuarioProvisorioLogout()
          this.usuarioAtual(this.usuario)
          localStorage.setItem('usuarioAtual', JSON.stringify(this.usuario))
          await cupom.verificaCupomUsuarioLogado()
          this.rotaAposLogin()
        }).catch((error) => {
          switch (error.code) {
            case 'auth/wrong-password':
              this.$fire({
                title: 'Não foi possível realizar o login',
                text: 'A Senha informada está incorreta.',
                type: 'error'
              }).then(r => {
                if (r.value) {
                  setTimeout(() => this.focarSenha(), 500)
                }
              })
              break
            case 'auth/user-not-found':
              this.$fire({
                title: 'Não foi possível realizar o login',
                text: 'Não há registro de usuário para esse identificador.',
                type: 'error'
              })
              break
            case 'auth/account-exists-with-different-credential':
              this.$fire({
                title: 'Não foi possível realizar o cadastro',
                text: 'Você já está cadastrado através de outro meio de login',
                type: 'error'
              })
              break
          }
        })
    },
    async login () {
      dbCadastro.collection('Clientes').doc(this.formLogin.email).get().then((doc) => {
        if (doc.exists) {
          if (doc.data().FormaLogin !== 'Convencional') {
            this.$fire({
              title: 'O seu e-mail está cadastrado para acesso com o ' + doc.data().FormaLogin,
              text: 'Clique em "OK" para fazer o login com o ' + doc.data().FormaLogin,
              type: 'warning',
              showCancelButton: true,
              cancelButtonText: 'Cancelar'
            }).then(r => {
              if (r.value) {
                this.loginExterno(doc.data().FormaLogin)
              }
            })
          } else {
            this.loginConvencional()
          }
        } else {
          this.$fire({
            title: 'Olá, seu e-mail não está cadastrado.',
            text: 'Você pode utilizar uma conta do Google ou do Facebook. Ou fazer um cadastro aqui no Ilha',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            type: 'warning',
            confirmButtonText: 'Faça seu cadastro'
          }).then(r => {
            if (r.value) {
              var usuario = {
                Email: this.formLogin.email
              }
              this.usuarioProvisorio(usuario)
              this.$router.push({name: 'Cadastrar', params: {mostrarLoginExterno: true}})
            }
          })
        }
      })
    },
    async loginExterno (formaLogin) {
      auth.signInWithPopup(formaLogin === 'Google' ? googleProvider : facebookProvider).then(async (data) => {
        let loader = this.$loading.show({
          container: null,
          fullPage: true,
          color: '#F85E28',
          loader: 'spinner',
          width: 100,
          height: 100,
          backgroundColor: '#ffffff',
          opacity: 0.5,
          zIndex: 999
        })
        dbCadastro.collection('Clientes').doc(data.additionalUserInfo.profile.email).get().then(async (doc) => {
          if (doc.exists) {
            this.usuario = {
              id: data.user.uid,
              NomeCompleto: data.user.displayName,
              PrimeiroNome: data.user.displayName.split(' ')[0],
              UltimoNome: data.user.displayName.split(' ')[1],
              Email: data.additionalUserInfo.profile.email,
              Cpf: doc.data().Cpf,
              Telefone: doc.data().Telefone,
              Token: data.user.xa,
              Foto: data.user.photoURL,
              EnderecoCep: doc.data().EnderecoCep,
              EnderecoRua: doc.data().EnderecoRua,
              EnderecoNumero: doc.data().EnderecoNumero,
              EnderecoBairro: doc.data().EnderecoBairro,
              EnderecoComplemento: doc.data().EnderecoComplemento,
              EnderecoCidade: doc.data().EnderecoCidade,
              EnderecoUF: doc.data().EnderecoUF,
              FormaLogin: formaLogin
            }
            if (doc.data().PrimeiroAcesso === true) {
              dbCadastro.collection('Clientes').doc(data.additionalUserInfo.profile.email).update({
                FormaLogin: formaLogin,
                id: data.user.uid,
                NomeCompleto: data.user.displayName,
                PrimeiroNome: data.user.displayName.split(' ')[0],
                UltimoNome: data.user.displayName.split(' ')[1],
                Email: data.additionalUserInfo.profile.email,
                Cpf: doc.data().Cpf,
                Telefone: doc.data().Telefone,
                Token: data.user.xa,
                Foto: data.user.photoURL,
                EnderecoCep: doc.data().EnderecoCep,
                EnderecoRua: doc.data().EnderecoRua,
                EnderecoNumero: doc.data().EnderecoNumero,
                EnderecoBairro: doc.data().EnderecoBairro,
                EnderecoComplemento: doc.data().EnderecoComplemento,
                EnderecoCidade: doc.data().EnderecoCidade,
                EnderecoUF: doc.data().EnderecoUF
              })
              this.usuarioAtual(this.usuario)
              localStorage.setItem('usuarioAtual', JSON.stringify(this.usuario))
             // await cupom.verificaCupomUsuarioLogado()
              loader.hide()
              this.rotaAposLogin()
            } else {
              dbCadastro.collection('Clientes').doc(data.additionalUserInfo.profile.email).update({
                FormaLogin: formaLogin,
                Token: data.user.xa,
                id: data.user.uid,
                Foto: data.user.photoURL
              })
              this.loginGoogleFacebook(true)
              this.usuarioProvisorio(this.usuario)
              loader.hide()
              this.$router.push({name: 'Cadastrar'})
            }
          } else {
            this.usuario = {
              id: data.user.uid,
              NomeCompleto: data.user.displayName,
              PrimeiroNome: data.user.displayName.split(' ')[0],
              UltimoNome: data.user.displayName.split(' ')[1],
              Email: data.additionalUserInfo.profile.email,
              Token: data.user.xa,
              Foto: data.user.photoURL,
              FormaLogin: formaLogin,
              PrimeiroAcesso: false
            }
            dbCadastro.collection('Clientes').doc(data.additionalUserInfo.profile.email).set(this.usuario)
            this.loginGoogleFacebook(true)
            this.usuarioProvisorio(this.usuario)
            loader.hide()
            this.$router.push({name: 'Cadastrar'})
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        switch (error.code) {
          case 'auth/wrong-password':
            this.$fire({
              title: 'Não foi possível realizar o login',
              text: 'A Senha informada está incorreta.',
              type: 'error'
            }).then(r => {
              if (r.value) {
                setTimeout(() => this.focarSenha(), 500)
              }
            })
            break
          case 'auth/user-not-found':
            this.$fire({
              title: 'Não foi possível realizar o login',
              text: 'Não há registro de usuário para esse identificador.',
              type: 'error'
            })
            break
          case 'auth/account-exists-with-different-credential':
            dbCadastro.collection('Clientes').doc(error.email).get().then((doc) => {
              this.$fire({
                title: doc.data().FormaLogin === 'Google' ? 'O seu e-mail está cadastrado para acesso com o ' + doc.data().FormaLogin : 'O seu e-mail está cadastrado para acesso convencional',
                text: doc.data().FormaLogin === 'Google' ? 'Para acessar o sistema com o ' + doc.data().FormaLogin + ', clique em "OK".' : 'Faça o login com seu e-mail e senha cadastrada.',
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar'
              }).then(r => {
                if (r.value) {
                  if (doc.data().FormaLogin === 'Google') {
                    this.loginExterno('Google')
                  } else {
                    // this.usuarioProvisorio(doc.data())
                    setTimeout(() => this.$refs.email.focus(), 500)
                  }
                }
              })
            })
            break
        }
      })
    },
    rotaAposLogin () {
      if (this.$store.state.menu.finalizacaoPedido === true) {
        this.$router.push({name: 'Pagamento', params: {id: this.$store.state.carrinho.idCarrinho}})
      } else {
        this.$router.push({name: 'Minha Conta'})
      }
    }
  }
}
</script>

<style scoped>
.content, .content2, .content3, .content4 {
  max-width: 1174px;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  grid-template-areas:
    "etapas"
    "etapas-titulo"
    "container"
}

.content2 {
  padding: 20px 10% 20px 0;
}

.content3 {
  padding: 20px 35% 20px 0;
}

@media (max-width: 960px) {
  .content, .content2, .content3, .content4 {
    margin: 0;
    padding: 6px;
    grid-template-columns: 1fr;
    grid-template-columns: 100%;
    grid-template-areas:
      "etapas"
      "etapas-titulo"
      "container"
  }
}

/* login */
.container, .container2, .container3, .container4 {
  grid-area: container;
  justify-self: center;
  display: grid;
}

.container {
  width: 80%;
  grid-template-columns: 1fr 1fr;
}

.container2 {
  width: 75%;
  grid-template-columns: 1fr 1fr;
}

.container3 {
  width: 95%;
  grid-template-columns: 1fr 1fr;
}

.container4 {
  width: 60%;
  grid-template-columns: 1fr;
}

.botao_alert {
    background: #2982dc !important;
    color: #fff !important;
    margin: 0 6px !important;
    padding: 8px 12px !important;
  }

.login, .login-outros  {
  width: 90%;
  justify-self: center;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px 10px 25px 10px;
  margin: 0 0 50px 0;
}

.titulo {
  font-size: 1.2rem;
  color: #2E9189;
  font-weight: 600;
  border-bottom: 1px solid #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.margin-top {
  margin: 15px 0;
}

.form {
  margin: 0 auto 30px auto;
  padding: 0 15%;
}

.label {
  padding: 0 5%;
  color: #333;
}

.label {
  text-align: left;
}

.form button {
  margin: 10px auto;
}

button {
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  border: 0;
  font-size: 1.05em;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
}

button:hover {
  transform: scale(1.1);
}

.bt-login {
  background: #2E9189;
}

.bt-login:hover {
  background: #186B65;
}

.bt-facebook {
 background: #4266AE;
 width: 80%;
}

.bt-login:hover {
  background: #186B65;
  transform: scale(1.1);
}

.bt-google {
  background: #4286F5;
  width: 80%;
}

.bt-google:hover {
  background: #4286F5;
}

.cadastrar {
  display: block;
  padding: 10px;
  cursor: pointer;
}

.acesso-cpf {
  display: block;
  padding: 10px;
  cursor: pointer;
}

.bt-cpf {
  background: #4286F5;
}

.bt-cpf:hover {
  background: #4286F5;
}

/* CADASTRO */
.cadastro {
  grid-area: cadastro;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px;
}

.cadastro-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.cadastro-form p {
  padding: 0 0 0 5%;
  margin: 20px 0 5px 0;
}

.bt-cadastro {
  background: #2E9189;
  margin: 20px 0;
}

.bt-cadastro:hover {
  background: #186B65;
}

.esqueci-senha {
  margin: 10px 0 0 0;
  cursor: pointer;
}

.esqueci-senha:hover {
  color: #186B65;
}

@media (max-width: 960px) {
  .cadastro-form {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .login, .login-outros {
    width: 85%;
    justify-self: center;
    padding: 10px 0;
  }
  .container4 {
    width: 85%;
  }
  .form {
    margin: 0 auto 30px auto;
    padding: 0 5%;
  }
}

@media (max-width: 660px) {
  .login, .login-outros {
    width: 98%;
  }
  .container4 {
    width: 98%;
  }
  .form {
    margin: 0 auto 30px auto;
    padding: 0 1px;
  }
  .cadastrar {
    padding: 0 10px;
  }
  .margin-top {
    margin: 5px 0;
  }
  .login, .login-outros  {
    padding: 5px 0 5px 0;
    margin: 0 0 5px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Login.vue